import { render } from "./defaultLayout.vue?vue&type=template&id=18850428"
import script from "./defaultLayout.vue?vue&type=script&lang=js"
export * from "./defaultLayout.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./defaultLayout.vue?vue&type=style&index=0&id=18850428&lang=scss&module=true"
cssModules["$style"] = style0
import "./defaultLayout.vue?vue&type=style&index=1&id=18850428&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__